import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";

import useComparison from "../../utils/validateComparison";

import { setNavigationAssets } from "../../../../store/actions/navigation.action";

import PageContent from "../../../../components/PageContent";
import PageLoading from "../../../../components/PageLoading";
import PageTitle from "../../../../components/PageTitle";
import CompareScores from "../../components/CompareScores/CompareScores";
import ReportsTabbar from "../../components/ReportsTabbar";

import { getGraphSource } from "../../../../store/helpers/uiHelper";

import DiscussParagraph from "../../../../components/DiscussParagraph";
import Motivator from "../../components/Motivator/Motivator";
import NoSubscription from "../../components/NoSubscription";
import { REPORT_TEXTS } from "../../utils/contentTexts";
import StressCurve from "../Stress/components/StressCurve";
import "./StressCompare.scss";

function StressCompare(props) {
  const { setNavigationAssets, comparedQuestionAverages, isFullReport } = props;

  useComparison();

  React.useEffect(() => {
    const navigation = {
      title: "COMPARE AND BENCHMARK",
      subtitle: "STRESS INDEX",
      tab: "COMPARE AND BENCHMARK",
    };
    setNavigationAssets(navigation);
  }, []);

  const texts = REPORT_TEXTS.benchmark.si;

  return (
    <PageLoading
      render={() => (
        <Fragment>
          <Motivator />
          <PageTitle title={texts.title} paragraphs={texts.subtitle}>
            {comparedQuestionAverages && (
              <CompareScores
                initialData={{
                  date: comparedQuestionAverages[0].date,
                  average: comparedQuestionAverages[0].si,
                }}
                lastData={{
                  date: comparedQuestionAverages[1].date,
                  average: comparedQuestionAverages[1].si,
                }}
                acronym="si"
              />
            )}
          </PageTitle>
          <PageContent>
            <ReportsTabbar compare={true} />
            {isFullReport ? (
              <>
                {comparedQuestionAverages && (
                  <div className="stress-compare__graphs">
                    <div className="stress-compare__graphs-dateBox">
                      <img
                        src={getGraphSource(comparedQuestionAverages[0].si)}
                        alt="Current score graph"
                        className="score"
                      />
                      <div className="stress-compare__graphs-date">
                        {
                          props.reportsToCompare.reportFrom.description.split(
                            " - "
                          )[1]
                        }
                      </div>
                    </div>
                    <div className="stress-compare__graphs-dateBox">
                      <img
                        src={getGraphSource(comparedQuestionAverages[1].si)}
                        alt="Current score graph"
                        className="score"
                      />
                      <div className="stress-compare__graphs-date">
                        {
                          props.reportsToCompare.reportTo.description.split(
                            " - "
                          )[1]
                        }
                      </div>
                    </div>
                  </div>
                )}
                <StressCurve />
                <DiscussParagraph />
              </>
            ) : (
              <NoSubscription reportType="Stress Indicator" />
            )}
          </PageContent>
        </Fragment>
      )}
    />
  );
}

StressCompare.propTypes = {
  setNavigationAssets: PropTypes.func,
  reportsToCompare: PropTypes.object,
  comparedQuestionAverages: PropTypes.array,
  isTeam360: PropTypes.bool,
  isFullReport: PropTypes.bool,
};

const mapStateToProps = ({ benchmarking, reports }) => {
  return {
    reportsToCompare: benchmarking.reportsToCompare,
    comparedQuestionAverages: benchmarking.comparedQuestionAverages,
    isFullReport:
      reports && reports.reportStatus && reports.reportStatus.is_full_report,
    isTeam360:
      reports && reports.reportStatus && reports.reportStatus.is_team_360,
  };
};

export default connect(mapStateToProps, {
  setNavigationAssets,
})(StressCompare);
